import { TestResult } from 'plugin-test-results-common';

export function getDeepLink(testResult: TestResult): string {
  const { jobId, parentUuid, jobWebUrl, methodUuid } = testResult;
  if (parentUuid && methodUuid) {
    const baseUrl =
      'https://bni-software-test-reports.storage.googleapis.com/job';
    return `${baseUrl}/${jobId}/index.html#suites/${parentUuid}/${methodUuid}/`;
  }
  return jobWebUrl;
}
